/**
 * @generated by kos:gen (kos/compiler/cli.mjs). DO NOT EDIT BY HAND.
 * Regenerate with `pnpm run kos:gen`; CI verifies drift via `pnpm run kos:validate`.
 * Source: frontmatter + headings of kos/site/src/content/docs/**. Deterministic: sorted by doc ID.
 */

/** All published docs pages, keyed by stable doc ID. */
export const kosRegistry = {
    'administration.access-controls': {
        id: 'administration.access-controls',
        url: '/administration/access-controls/',
        title: 'Access controls',
        description: 'Create access groups that grant a role and a set of tenants, and manage who is in them.',
        sections: {
            'the-access-groups-table': 'the-access-groups-table',
            'the-admins-group': 'the-admins-group',
            'the-group-side-sheet': 'the-group-side-sheet',
            'create-a-group': 'create-a-group',
            'add-a-member-to-a-group': 'add-a-member-to-a-group',
            'change-a-groups-tenants': 'change-a-groups-tenants',
            'remove-a-member': 'remove-a-member',
            'delete-a-group': 'delete-a-group',
            'related': 'related',
        },
    },
    'administration.alert-recipients': {
        id: 'administration.alert-recipients',
        url: '/administration/alert-recipients/',
        title: 'Alert recipients',
        description: 'Choose who receives an alert by email, and at which severities.',
        sections: {
            'email-delivery': 'email-delivery',
            'the-recipients-table': 'the-recipients-table',
            'who-can-be-a-recipient': 'who-can-be-a-recipient',
            'add-a-recipient': 'add-a-recipient',
            'change-severities': 'change-severities',
            'remove-a-recipient': 'remove-a-recipient',
            'automatic-lockout': 'automatic-lockout',
            'related': 'related',
        },
    },
    'administration.change-history': {
        id: 'administration.change-history',
        url: '/administration/change-history/',
        title: 'Change history',
        description: 'A per-tenant trail of actions taken through Octiga.',
        sections: {},
    },
    'administration.profile': {
        id: 'administration.profile',
        url: '/administration/profile/',
        title: 'Profile',
        description: 'Edit your own Microsoft 365 profile and photo from inside Octiga, and see the access groups and roles Octiga gives you.',
        sections: {
            'opening-profile': 'opening-profile',
            'the-microsoft-365-view': 'the-microsoft-365-view',
            'edit-your-profile': 'edit-your-profile',
            'change-or-remove-your-photo': 'change-or-remove-your-photo',
            'the-octiga-view': 'the-octiga-view',
            'if-a-save-doesnt-go-through': 'if-a-save-doesnt-go-through',
        },
    },
    'administration.psa-integrations': {
        id: 'administration.psa-integrations',
        url: '/administration/psa-integrations/',
        title: 'PSA integrations',
        description: 'Connect ConnectWise, Datto Autotask or HaloPSA so alerts raise tickets automatically.',
        sections: {
            'how-every-psa-connection-works': 'how-every-psa-connection-works',
            'connect-a-psa': 'connect-a-psa',
            'the-psas-page': 'the-psas-page',
            'client-mapping': 'client-mapping',
            'ticket-config': 'ticket-config',
            'connection-states': 'connection-states',
            'when-the-connection-is-failing': 'when-the-connection-is-failing',
            'edit-the-connection': 'edit-the-connection',
            'disconnect-reconnect-or-delete': 'disconnect-reconnect-or-delete',
            'credentials': 'credentials',
            'ticket-configuration': 'ticket-configuration',
            'credentials-1': 'credentials-1',
            'ticket-configuration-1': 'ticket-configuration-1',
            'credentials-2': 'credentials-2',
            'ticket-configuration-2': 'ticket-configuration-2',
            'related': 'related',
        },
    },
    'administration.reports': {
        id: 'administration.reports',
        url: '/administration/reports/',
        title: 'Report schedules',
        description: 'Email each tenant\'s security report every week or every month, and choose who receives it.',
        sections: {
            'what-a-schedule-sends': 'what-a-schedule-sends',
            'run-a-report-on-demand': 'run-a-report-on-demand',
            'reading-the-list': 'reading-the-list',
            'every-tenant-with-a-schedule': 'every-tenant-with-a-schedule',
            'a-tenants-schedules': 'a-tenants-schedules',
            'the-schedule-editor': 'the-schedule-editor',
            'create-a-schedule': 'create-a-schedule',
            'pause-a-schedule': 'pause-a-schedule',
            'change-recipients': 'change-recipients',
            'delete-a-schedule': 'delete-a-schedule',
            'related': 'related',
        },
    },
    'administration.subscription': {
        id: 'administration.subscription',
        url: '/administration/subscription/',
        title: 'Subscription',
        description: 'Your MSP\'s Octiga plan and usage.',
        sections: {},
    },
    'administration.white-labelling': {
        id: 'administration.white-labelling',
        url: '/administration/white-labelling/',
        title: 'White labelling',
        description: 'Replace Octiga\'s own branding with your MSP\'s.',
        sections: {},
    },
    'baselines': {
        id: 'baselines',
        url: '/baselines/',
        title: 'Baselines',
        description: 'Browse Octiga\'s baselines, grouped by the kind of Microsoft 365 policy they configure.',
        sections: {},
    },
    'baselines.access-management': {
        id: 'baselines.access-management',
        url: '/baselines/access-management/',
        title: 'Access Management',
        description: 'Baselines that set how people sign in, flag dormant accounts, and control app consent and Microsoft\'s support access, at tenant and group scope.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.access-management.account-enabled': {
        id: 'baselines.access-management.account-enabled',
        url: '/baselines/access-management/account-enabled/',
        title: 'Shared Mailbox Sign In',
        description: 'Keeps direct sign-in blocked for each shared mailbox it applies to, the default, so the mailbox is used only through delegated access, with an exemption for any account an integration signs in as.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.access-management.admin-consent-workflow': {
        id: 'baselines.access-management.admin-consent-workflow',
        url: '/baselines/access-management/admin-consent-workflow/',
        title: 'Admin Consent Workflow',
        description: 'Control how users request approval for apps that need high-level permissions.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-certificate-based': {
        id: 'baselines.access-management.authentication-methods-certificate-based',
        url: '/baselines/access-management/authentication-methods-certificate-based/',
        title: 'Authentication Method Policy - Certificate-Based Authentication',
        description: 'Certificate-based authentication (CBA) allows users to authenticate using X.509 certificates issued by an enterprise or federated certificate authority.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.access-management.authentication-methods-email-otp': {
        id: 'baselines.access-management.authentication-methods-email-otp',
        url: '/baselines/access-management/authentication-methods-email-otp/',
        title: 'Authentication Method Policy - Email OTP',
        description: 'Send a one-time code to a user’s email for authentication.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-fido2': {
        id: 'baselines.access-management.authentication-methods-fido2',
        url: '/baselines/access-management/authentication-methods-fido2/',
        title: 'Authentication Method Policy - Passkey (FIDO2)',
        description: 'FIDO2 security keys are hardware-based passwordless authentication devices that comply with the FIDO2 standard.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-microsoft-authenticator': {
        id: 'baselines.access-management.authentication-methods-microsoft-authenticator',
        url: '/baselines/access-management/authentication-methods-microsoft-authenticator/',
        title: 'Authentication Method Policy - Microsoft Authenticator',
        description: 'Controls how Microsoft Authenticator is used for push and passwordless authentication, which users it applies to, and whether additional security details (app name, location, companion apps) appear in authentication prompts.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-sms': {
        id: 'baselines.access-management.authentication-methods-sms',
        url: '/baselines/access-management/authentication-methods-sms/',
        title: 'Authentication Method Policy - SMS',
        description: 'Send a one-time code via SMS to a user\'s mobile phone for authentication.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-temporary-access-pass': {
        id: 'baselines.access-management.authentication-methods-temporary-access-pass',
        url: '/baselines/access-management/authentication-methods-temporary-access-pass/',
        title: 'Authentication Method Policy - Temporary Access Pass',
        description: 'Temporary Access Pass (TAP) provides time-limited passcodes that can be used for authentication and onboarding scenarios.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.authentication-methods-voice': {
        id: 'baselines.access-management.authentication-methods-voice',
        url: '/baselines/access-management/authentication-methods-voice/',
        title: 'Authentication Method Policy - Voice Call',
        description: 'Ensures that the voice call authentication method is securely configured.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.access-management.cross-tenant-access-settings': {
        id: 'baselines.access-management.cross-tenant-access-settings',
        url: '/baselines/access-management/cross-tenant-access-settings/',
        title: 'Cross-Tenant Access Settings',
        description: 'Ensures cross-tenant access policies are configured to control B2B inbound and outbound trust settings, preventing unauthorised access from or to external tenants.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.access-management.domain-password-policy': {
        id: 'baselines.access-management.domain-password-policy',
        url: '/baselines/access-management/domain-password-policy/',
        title: 'Password Policy',
        description: 'The Domain Password Policy enforces password expiration and complexity requirements to enhance account security.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.dormant-admins': {
        id: 'baselines.access-management.dormant-admins',
        url: '/baselines/access-management/dormant-admins/',
        title: 'Dormant Admins',
        description: 'Define when admins are considered dormant.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.access-management.dormant-users': {
        id: 'baselines.access-management.dormant-users',
        url: '/baselines/access-management/dormant-users/',
        title: 'Dormant Users',
        description: 'Define when users are considered dormant.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.access-management.mfa': {
        id: 'baselines.access-management.mfa',
        url: '/baselines/access-management/mfa/',
        title: 'MFA (Deprecated)',
        description: 'Reports whether each user it applies to has registered at least one multi-factor authentication method; Octiga no longer offers it but still checks it where it\'s already in use.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.access-management.org-customer-lockbox': {
        id: 'baselines.access-management.org-customer-lockbox',
        url: '/baselines/access-management/org-customer-lockbox/',
        title: 'Customer Lockbox',
        description: 'Customer Lockbox requires explicit approval from your organization before Microsoft engineers can access your data during support operations.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.password-rule-settings': {
        id: 'baselines.access-management.password-rule-settings',
        url: '/baselines/access-management/password-rule-settings/',
        title: 'Password Protection',
        description: 'Keeps Microsoft Entra\'s account lockout and banned-password protection at Octiga\'s recommended values, so repeated failed sign-ins lock the account and weak passwords are refused.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.per-user-mfa-state': {
        id: 'baselines.access-management.per-user-mfa-state',
        url: '/baselines/access-management/per-user-mfa-state/',
        title: 'Per User MFA',
        description: 'Records the per-user MFA state you want each user or group to have, while Octiga enforces and remediates MFA through its Enforce MFA Conditional Access baseline.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.access-management.security-defaults-policy': {
        id: 'baselines.access-management.security-defaults-policy',
        url: '/baselines/access-management/security-defaults-policy/',
        title: 'Security Defaults Policy',
        description: 'Security defaults is a set of basic identity security mechanisms recommended by Microsoft.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.access-management.user-consent-work-flow': {
        id: 'baselines.access-management.user-consent-work-flow',
        url: '/baselines/access-management/user-consent-work-flow/',
        title: 'User Consent Settings',
        description: 'Control whether and how end users can grant consent to applications.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.adding-a-baseline': {
        id: 'baselines.adding-a-baseline',
        url: '/baselines/adding-a-baseline/',
        title: 'Adding a baseline',
        description: 'Add, configure or remove a single baseline on a tenant, a user or a group, without deploying a whole scheme.',
        sections: {
            'adding-an-org-level-baseline-to-a-tenant': 'adding-an-org-level-baseline-to-a-tenant',
            'adding-a-baseline-to-one-user': 'adding-a-baseline-to-one-user',
            'adding-a-baseline-to-a-group': 'adding-a-baseline-to-a-group',
            'setting-the-baselines-values': 'setting-the-baselines-values',
            'turning-on-automatic-remediation': 'turning-on-automatic-remediation',
            'removing-a-baseline': 'removing-a-baseline',
            'check-it-worked': 'check-it-worked',
            'if-it-didnt': 'if-it-didnt',
        },
    },
    'baselines.audit': {
        id: 'baselines.audit',
        url: '/baselines/audit/',
        title: 'Audit',
        description: 'Baselines that keep mailbox and unified audit logging turned on across a tenant.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.audit.org-mailbox-audit-log': {
        id: 'baselines.audit.org-mailbox-audit-log',
        url: '/baselines/audit/org-mailbox-audit-log/',
        title: 'Mailbox Audit Log',
        description: 'Mailbox Audit Logging tracks actions taken by users and administrators on mailboxes, providing visibility into mailbox activity for security and compliance purposes.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.audit.org-unified-audit-log': {
        id: 'baselines.audit.org-unified-audit-log',
        url: '/baselines/audit/org-unified-audit-log/',
        title: 'Unified Audit Log',
        description: 'Enable or disable the Unified Audit Log for the entire organisation.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy': {
        id: 'baselines.conditional-access-policy',
        url: '/baselines/conditional-access-policy/',
        title: 'Conditional Access Policy',
        description: 'Baselines that configure Conditional Access policies in Microsoft Entra ID, such as blocking legacy authentication and enforcing MFA.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.conditional-access-policy.cap-app-enforced-restriction-unmanaged-devices': {
        id: 'baselines.conditional-access-policy.cap-app-enforced-restriction-unmanaged-devices',
        url: '/baselines/conditional-access-policy/cap-app-enforced-restriction-unmanaged-devices/',
        title: 'Application Enforced Restrictions For Unmanaged Devices.',
        description: 'This Conditional Access Policy blocks or restricts access to SharePoint, OneDrive, and Exchange content from unmanaged devices.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy.cap-app-protection-policy': {
        id: 'baselines.conditional-access-policy.cap-app-protection-policy',
        url: '/baselines/conditional-access-policy/cap-app-protection-policy/',
        title: 'Require Approved Client Apps',
        description: 'This Conditional Access Policy requires users to access resources only through apps protected by app protection policies (Microsoft retired the approved client app grant on 30 June 2026).',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-block-device-code-flow': {
        id: 'baselines.conditional-access-policy.cap-block-device-code-flow',
        url: '/baselines/conditional-access-policy/cap-block-device-code-flow/',
        title: 'Block Device Code Flow',
        description: 'This Conditional Access Policy blocks the device code authentication flow.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.conditional-access-policy.cap-enforce-mfa': {
        id: 'baselines.conditional-access-policy.cap-enforce-mfa',
        url: '/baselines/conditional-access-policy/cap-enforce-mfa/',
        title: 'Enforce MFA',
        description: 'This Conditional Access Policy enforces Multi-Factor Authentication (MFA) for all users, requiring an additional verification step beyond just a password.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy.cap-generic': {
        id: 'baselines.conditional-access-policy.cap-generic',
        url: '/baselines/conditional-access-policy/cap-generic/',
        title: 'Octiga Generic Conditional Access Policy',
        description: 'Lets you define your own Conditional Access policy in a scheme, which Octiga then deploys to each tenant, checks and remediates like any other baseline.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-legacy-auth': {
        id: 'baselines.conditional-access-policy.cap-legacy-auth',
        url: '/baselines/conditional-access-policy/cap-legacy-auth/',
        title: 'Block Legacy Authentication',
        description: 'This Conditional Access Policy blocks the use of legacy authentication methods that do not support modern security controls.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy.cap-no-persistent-browsers': {
        id: 'baselines.conditional-access-policy.cap-no-persistent-browsers',
        url: '/baselines/conditional-access-policy/cap-no-persistent-browsers/',
        title: 'No persistent Browser Sessions',
        description: 'This Conditional Access Policy prevents users from maintaining persistent browser sessions, requiring them to re-authenticate more frequently.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-require-compliant-or-hybrid-azure-ad-joined-device': {
        id: 'baselines.conditional-access-policy.cap-require-compliant-or-hybrid-azure-ad-joined-device',
        url: '/baselines/conditional-access-policy/cap-require-compliant-or-hybrid-azure-ad-joined-device/',
        title: 'Require Compliant Or Hybrid Azure AD Joined Device.',
        description: 'This Conditional Access Policy requires that administrators sign in only from devices that are compliant or hybrid Azure AD joined.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy.cap-restrict-azure-access': {
        id: 'baselines.conditional-access-policy.cap-restrict-azure-access',
        url: '/baselines/conditional-access-policy/cap-restrict-azure-access/',
        title: 'Restrict Access To Azure Portal',
        description: 'Deploys a Conditional Access policy that blocks sign-in to the Azure portal, Azure PowerShell and the Azure CLI for everyone it covers, or requires MFA instead.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-restrict-microsoft-admin-portal-access': {
        id: 'baselines.conditional-access-policy.cap-restrict-microsoft-admin-portal-access',
        url: '/baselines/conditional-access-policy/cap-restrict-microsoft-admin-portal-access/',
        title: 'Restrict Access To Microsoft Admin Portal',
        description: 'Deploys a Conditional Access policy that blocks sign-in to Microsoft\'s admin portals, such as the Microsoft 365 and Entra admin centres, for everyone it covers, or requires MFA instead.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-risky-signin': {
        id: 'baselines.conditional-access-policy.cap-risky-signin',
        url: '/baselines/conditional-access-policy/cap-risky-signin/',
        title: 'Sign-In Risk-Based Multifactor Authentication.',
        description: 'This Conditional Access Policy requires multifactor authentication (MFA) for sign-ins that are determined to be risky, especially for administrator accounts.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-securing-security-info-registration': {
        id: 'baselines.conditional-access-policy.cap-securing-security-info-registration',
        url: '/baselines/conditional-access-policy/cap-securing-security-info-registration/',
        title: 'Securing Security Info Registration',
        description: 'This Conditional Access Policy ensures that users register their security information (such as MFA methods) in a secure manner.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.cap-un-supported-device-block': {
        id: 'baselines.conditional-access-policy.cap-un-supported-device-block',
        url: '/baselines/conditional-access-policy/cap-un-supported-device-block/',
        title: 'Block Unknown Or Unsupported Device Access',
        description: 'Users will be blocked from accessing company resources when the device type is unknown or unsupported.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.conditional-access-policy.legacy-auth-conditional-access-policy': {
        id: 'baselines.conditional-access-policy.legacy-auth-conditional-access-policy',
        url: '/baselines/conditional-access-policy/legacy-auth-conditional-access-policy/',
        title: 'Legacy Auth Conditional Access Policy - DEPRECATED NAME',
        description: 'Blocks sign-ins over legacy authentication protocols through an older Conditional Access policy; Octiga no longer offers it, and Block Legacy Authentication replaces it.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.conditional-access-policy.mfa-conditional-access-policy': {
        id: 'baselines.conditional-access-policy.mfa-conditional-access-policy',
        url: '/baselines/conditional-access-policy/mfa-conditional-access-policy/',
        title: 'MFA Conditional Access Policy - DEPRECATED',
        description: 'Requires MFA for admin roles only through an older Conditional Access policy; Octiga no longer offers it, and Enforce MFA, which covers every user, replaces it.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.creating-a-scheme': {
        id: 'baselines.creating-a-scheme',
        url: '/baselines/creating-a-scheme/',
        title: 'Creating a scheme',
        description: 'Create an org-level or user-level scheme, fill it with baselines and their values, and import, duplicate, star or delete schemes.',
        sections: {
            'create-the-scheme': 'create-the-scheme',
            'add-baselines': 'add-baselines',
            'create-a-custom-conditional-access-policy': 'create-a-custom-conditional-access-policy',
            'set-each-baselines-values': 'set-each-baselines-values',
            'import-baselines-from-another-scheme': 'import-baselines-from-another-scheme',
            'remove-a-baseline-from-a-scheme': 'remove-a-baseline-from-a-scheme',
            'duplicate-a-scheme': 'duplicate-a-scheme',
            'delete-a-scheme': 'delete-a-scheme',
            'star-a-scheme': 'star-a-scheme',
            'check-it-worked': 'check-it-worked',
            'if-it-didnt': 'if-it-didnt',
        },
    },
    'baselines.deploying-a-scheme': {
        id: 'baselines.deploying-a-scheme',
        url: '/baselines/deploying-a-scheme/',
        title: 'Deploying a scheme',
        description: 'Step through the deploy wizard to apply a scheme to a tenant, groups or users, and see what Managed and Direct do at deploy time.',
        sections: {
            'managed-or-direct-by-target': 'managed-or-direct-by-target',
            'org-level-rules': 'org-level-rules',
            'group-and-user-rules': 'group-and-user-rules',
            'reading-the-result': 'reading-the-result',
            'check-it-worked': 'check-it-worked',
            'if-it-didnt': 'if-it-didnt',
            'where-you-can-start-a-deploy': 'where-you-can-start-a-deploy',
        },
    },
    'baselines.deviations': {
        id: 'baselines.deviations',
        url: '/baselines/deviations/',
        title: 'Deviations',
        description: 'What a deviation is, the four verdicts Octiga can reach, and where you see them in Octiga.',
        sections: {
            'the-four-verdicts': 'the-four-verdicts',
            'where-you-see-them': 'where-you-see-them',
            'excluded': 'excluded',
            'not-assessed': 'not-assessed',
            'how-fresh-this-is': 'how-fresh-this-is',
            'retention': 'retention',
        },
    },
    'baselines.email-security': {
        id: 'baselines.email-security',
        url: '/baselines/email-security/',
        title: 'Email Security',
        description: 'Baselines that configure Exchange Online mail flow and anti-malware, anti-phishing and anti-spam protections.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.email-security.anti-malware-policy': {
        id: 'baselines.email-security.anti-malware-policy',
        url: '/baselines/email-security/anti-malware-policy/',
        title: 'Anti Malware Policy (Default)',
        description: 'Comprehensive anti-malware protection for Exchange Online — blocks known malicious file attachment types and alerts administrators when internal senders are detected sending malware.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.anti-phish-policy': {
        id: 'baselines.email-security.anti-phish-policy',
        url: '/baselines/email-security/anti-phish-policy/',
        title: 'Standard Default Anti Phishing Policy',
        description: 'The Standard Default Anti-Phishing Policy provides protection for all Exchange mailboxes, helping to detect and block phishing attempts and spoofed messages.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.auto-forward-block-transport-rule': {
        id: 'baselines.email-security.auto-forward-block-transport-rule',
        url: '/baselines/email-security/auto-forward-block-transport-rule/',
        title: 'Automatic Forwarding - Block',
        description: 'This transport rule blocks automatic email forwarding to external recipients.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.dkim-signing-config': {
        id: 'baselines.email-security.dkim-signing-config',
        url: '/baselines/email-security/dkim-signing-config/',
        title: 'DKIM Signing For Default Domain',
        description: 'Enable or disable DKIM signing for the tenant’s default domain.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.hosted-content-filter-policy': {
        id: 'baselines.email-security.hosted-content-filter-policy',
        url: '/baselines/email-security/hosted-content-filter-policy/',
        title: 'Anti Spam Inbound Policy (Default)',
        description: 'The default Exchange Online Protection (EOP) anti-spam inbound policy defines how incoming messages are handled based on spam confidence levels, bulk thresholds, and HTML content checks.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.hosted-outbound-spam-filter-policy': {
        id: 'baselines.email-security.hosted-outbound-spam-filter-policy',
        url: '/baselines/email-security/hosted-outbound-spam-filter-policy/',
        title: 'Default Hosted Outbound Spam Filter Policy',
        description: 'A default Exchange Online Protection (EOP) outbound spam filter policy that monitors and blocks suspicious outbound mail, helping MSPs detect and prevent compromised accounts from sending spam or malicious content.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.email-security.malware-file-types-filter-policy': {
        id: 'baselines.email-security.malware-file-types-filter-policy',
        url: '/baselines/email-security/malware-file-types-filter-policy/',
        title: 'Malicious Attachment Types Filter Policy - DEPRECATED',
        description: 'Checks only the blocked-attachment file filter in the Default anti-malware policy; Octiga no longer offers it, and that setting is now part of Anti Malware Policy (Default).',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.malware-internal-sender-filter-notification-policy': {
        id: 'baselines.email-security.malware-internal-sender-filter-notification-policy',
        url: '/baselines/email-security/malware-internal-sender-filter-notification-policy/',
        title: 'Malware Internal Sender Filter Notification Policy - DEPRECATED',
        description: 'Checks only the internal-sender malware alert setting in the Default anti-malware policy; Octiga no longer offers it, and that setting is now part of Anti Malware Policy (Default).',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.email-security.org-auto-forwarding': {
        id: 'baselines.email-security.org-auto-forwarding',
        url: '/baselines/email-security/org-auto-forwarding/',
        title: 'Mail Auto Forwarding',
        description: 'This setting controls whether users can automatically forward email to external recipients.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.org-direct-send': {
        id: 'baselines.email-security.org-direct-send',
        url: '/baselines/email-security/org-direct-send/',
        title: 'Direct Send',
        description: 'This setting controls whether Direct Send is enabled for your organization.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.email-security.org-smtp': {
        id: 'baselines.email-security.org-smtp',
        url: '/baselines/email-security/org-smtp/',
        title: 'SMTP Access',
        description: 'This setting controls whether SMTP (Simple Mail Transfer Protocol) is enabled or disabled for your organization.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.email-security.preset-eop-protection-policy-rule-standard': {
        id: 'baselines.email-security.preset-eop-protection-policy-rule-standard',
        url: '/baselines/email-security/preset-eop-protection-policy-rule-standard/',
        title: 'Preset EOP Policy (Standard)',
        description: 'Applies Microsoft\'s Standard preset EOP policy, providing a managed baseline of spam, malware, and phishing protection.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.preset-eop-protection-policy-rule-strict': {
        id: 'baselines.email-security.preset-eop-protection-policy-rule-strict',
        url: '/baselines/email-security/preset-eop-protection-policy-rule-strict/',
        title: 'Preset EOP Policy (Strict)',
        description: 'Applies Microsoft\'s Strict preset EOP policy, delivering a higher level of anti-spam, anti-malware, and anti-phishing protection.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.safe-attachment-policy': {
        id: 'baselines.email-security.safe-attachment-policy',
        url: '/baselines/email-security/safe-attachment-policy/',
        title: 'Safe Attachments Policy (Octiga)',
        description: 'Microsoft Defender for Office 365 Safe Attachments scans email attachments in a virtual sandbox environment before delivering them to recipients.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.email-security.safe-links-policy': {
        id: 'baselines.email-security.safe-links-policy',
        url: '/baselines/email-security/safe-links-policy/',
        title: 'Safe Links Policy (Octiga)',
        description: 'Microsoft Defender for Office 365 Safe Links scans URLs in email messages and Office documents in real time.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.groups-and-priority': {
        id: 'baselines.groups-and-priority',
        url: '/baselines/groups-and-priority/',
        title: 'Groups and priority',
        description: 'How Octiga decides which value a user gets when several sources supply one, and how to set the priority of the Azure groups it tracks.',
        sections: {
            'resolution-order': 'resolution-order',
            'the-priority-stack': 'the-priority-stack',
            'group-direct-baselines': 'group-direct-baselines',
            'the-groups-page': 'the-groups-page',
            'adding-a-group': 'adding-a-group',
            'the-group-menu': 'the-group-menu',
            'the-groups-own-detail': 'the-groups-own-detail',
            'groups-on-the-user-roster': 'groups-on-the-user-roster',
            'detach-behaviours': 'detach-behaviours',
            'vocabulary': 'vocabulary',
        },
    },
    'baselines.intune': {
        id: 'baselines.intune',
        url: '/baselines/intune/',
        title: 'Intune',
        description: 'Baselines that configure Intune compliance and configuration policies for Windows, iOS/iPadOS, macOS and Android devices.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.intune.android-compliance-policy': {
        id: 'baselines.intune.android-compliance-policy',
        url: '/baselines/intune/android-compliance-policy/',
        title: 'Android Enterprise - Compliance Policy',
        description: 'Requires company-owned Android devices to have a PIN, encrypted storage, Android 12 or later and a passing Play Integrity check before Intune treats them as compliant.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.intune.configuration-policy-windows-chrome-block-password-saving': {
        id: 'baselines.intune.configuration-policy-windows-chrome-block-password-saving',
        url: '/baselines/intune/configuration-policy-windows-chrome-block-password-saving/',
        title: 'Windows 10 or later Configuration Policy - Block Password Saving In Google Chrome',
        description: 'Deploys an Intune configuration profile that stops Google Chrome saving passwords in its password manager on the tenant\'s Windows devices.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.intune.configuration-policy-windows-edge-block-password-saving': {
        id: 'baselines.intune.configuration-policy-windows-edge-block-password-saving',
        url: '/baselines/intune/configuration-policy-windows-edge-block-password-saving/',
        title: 'Windows 10 or later Configuration Policy - Block Password Saving In Microsoft Edge',
        description: 'Deploys an Intune configuration profile that stops Microsoft Edge saving passwords and turns off Edge sync on the tenant\'s Windows devices.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.intune.configuration-policy-windows-laps': {
        id: 'baselines.intune.configuration-policy-windows-laps',
        url: '/baselines/intune/configuration-policy-windows-laps/',
        title: 'Windows 10 or later Configuration Policy - Windows LAPS Policy',
        description: 'Deploys an Intune Windows LAPS policy that randomises each Windows device\'s built-in local administrator password, rotates it every 30 days and backs it up to Microsoft Entra ID.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'nist': 'nist',
        },
    },
    'baselines.intune.ios-compliance-policy': {
        id: 'baselines.intune.ios-compliance-policy',
        url: '/baselines/intune/ios-compliance-policy/',
        title: 'iOS/iPadOS - Compliance Policy',
        description: 'Requires iPhones and iPads to have an alphanumeric passcode, no jailbreak, a managed email profile and iOS 15 or later before Intune treats them as compliant.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.intune.mac-os-compliance-policy': {
        id: 'baselines.intune.mac-os-compliance-policy',
        url: '/baselines/intune/mac-os-compliance-policy/',
        title: 'MAC OS - Compliance Policy',
        description: 'Requires Macs to have an alphanumeric password, FileVault encryption, System Integrity Protection, the firewall on and macOS 12 or later before Intune treats them as compliant.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.intune.windows10compliance-policy': {
        id: 'baselines.intune.windows10compliance-policy',
        url: '/baselines/intune/windows10compliance-policy/',
        title: 'Windows 10 Or Later - Compliance Policy',
        description: 'This compliance policy ensures that Windows 10 and later devices meet organizational security standards.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.mobile-access': {
        id: 'baselines.mobile-access',
        url: '/baselines/mobile-access/',
        title: 'Mobile Access',
        description: 'The baseline that configures the default mobile device mailbox policy for Exchange Online.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.mobile-access.mobile-device-mailbox-policy': {
        id: 'baselines.mobile-access.mobile-device-mailbox-policy',
        url: '/baselines/mobile-access/mobile-device-mailbox-policy/',
        title: 'Default Mobile Device Mailbox Policy',
        description: 'Controls the default ActiveSync mobile device policy applied to mailboxes, managing security requirements for devices that sync email via Exchange.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.remediation': {
        id: 'baselines.remediation',
        url: '/baselines/remediation/',
        title: 'Remediation',
        description: 'Turn on automatic remediation or fix a deviation on demand, follow each run as Octiga writes the fix to Microsoft 365, and see past runs on the Logs tab.',
        sections: {
            'automatic-or-manual': 'automatic-or-manual',
            'turning-on-automatic-remediation': 'turning-on-automatic-remediation',
            'fixing-a-deviation-manually': 'fixing-a-deviation-manually',
            'from-the-baseline-editor': 'from-the-baseline-editor',
            'remediate-a-group': 'remediate-a-group',
            'follow-a-run': 'follow-a-run',
            'row-states': 'row-states',
            'when-a-run-doesnt-finish-cleanly': 'when-a-run-doesnt-finish-cleanly',
            'when-octiga-skips-a-baseline': 'when-octiga-skips-a-baseline',
            'see-past-runs': 'see-past-runs',
            'what-octiga-writes': 'what-octiga-writes',
        },
    },
    'baselines.remote-access': {
        id: 'baselines.remote-access',
        url: '/baselines/remote-access/',
        title: 'Remote Access',
        description: 'Baselines that control which mail-access protocols and modern-authentication settings are available to a tenant or a group.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.remote-access.active-sync-enabled': {
        id: 'baselines.remote-access.active-sync-enabled',
        url: '/baselines/remote-access/active-sync-enabled/',
        title: 'ActiveSync Access',
        description: 'Keeps Exchange ActiveSync access switched on for each mailbox it applies to, the default, so native phone mail apps keep syncing, or requires it off where you choose.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.ews-enabled': {
        id: 'baselines.remote-access.ews-enabled',
        url: '/baselines/remote-access/ews-enabled/',
        title: 'EWS Access',
        description: 'Keeps Exchange Web Services (EWS) access switched on for each mailbox it applies to, the default, so Outlook for Mac and consented apps keep working, or requires it off where you choose.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.imap-enabled': {
        id: 'baselines.remote-access.imap-enabled',
        url: '/baselines/remote-access/imap-enabled/',
        title: 'IMAP Access',
        description: 'Keeps IMAP access switched off for each mailbox it applies to, the default, so older mail clients can\'t use the legacy protocol, or requires it on where you choose.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.legacy-auth-protocols-enabled': {
        id: 'baselines.remote-access.legacy-auth-protocols-enabled',
        url: '/baselines/remote-access/legacy-auth-protocols-enabled/',
        title: 'SharePoint Modern Auth Enforced',
        description: 'This policy enforces the use of modern authentication protocols for SharePoint by disabling legacy authentication methods.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.remote-access.mapi-enabled': {
        id: 'baselines.remote-access.mapi-enabled',
        url: '/baselines/remote-access/mapi-enabled/',
        title: 'MAPI Access',
        description: 'Keeps MAPI access switched on for each mailbox it applies to, the default, so classic Outlook for Windows can connect, or requires it off where you choose.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.org-modern-auth': {
        id: 'baselines.remote-access.org-modern-auth',
        url: '/baselines/remote-access/org-modern-auth/',
        title: 'Modern Authentication',
        description: 'Modern Authentication uses OAuth 2.0 to provide secure access to Microsoft 365 services.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
        },
    },
    'baselines.remote-access.outlook-mobile-enabled': {
        id: 'baselines.remote-access.outlook-mobile-enabled',
        url: '/baselines/remote-access/outlook-mobile-enabled/',
        title: 'Outlook Mobile Access',
        description: 'Keeps Outlook for iOS and Android access switched on for each mailbox it applies to, the default, or requires it off where you choose, separately from ActiveSync.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.owa-enabled': {
        id: 'baselines.remote-access.owa-enabled',
        url: '/baselines/remote-access/owa-enabled/',
        title: 'OWA Access',
        description: 'Keeps Outlook on the web access switched on for each mailbox it applies to, the default, or requires it off for users who never read mail in a browser.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.pop3enabled': {
        id: 'baselines.remote-access.pop3enabled',
        url: '/baselines/remote-access/pop3enabled/',
        title: 'POP3 Access',
        description: 'Keeps POP3 access switched off for each mailbox it applies to, the default, so older mail clients can\'t use the legacy protocol, or requires it on where you choose.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.remote-access.smtp-client-auth-disabled': {
        id: 'baselines.remote-access.smtp-client-auth-disabled',
        url: '/baselines/remote-access/smtp-client-auth-disabled/',
        title: 'SMTP Client Authentication',
        description: 'Sets whether each mailbox it applies to allows Authenticated SMTP for sending mail, following the tenant-wide switch by default or requiring it on or off for the mailbox itself.',
        sections: {
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
        },
    },
    'baselines.schemes': {
        id: 'baselines.schemes',
        url: '/baselines/schemes/',
        title: 'Schemes',
        description: 'What a scheme is, how org-level and user-level schemes differ, and what Managed and Direct mean.',
        sections: {
            'org-level-and-user-level-schemes': 'org-level-and-user-level-schemes',
            'managed-and-direct': 'managed-and-direct',
            'the-library-screen': 'the-library-screen',
            'scheme-detail': 'scheme-detail',
            'attached-tenants': 'attached-tenants',
            'default-scheme': 'default-scheme',
            'vocabulary': 'vocabulary',
        },
    },
    'baselines.sharing': {
        id: 'baselines.sharing',
        url: '/baselines/sharing/',
        title: 'Sharing',
        description: 'Baselines that configure how SharePoint Online content can be shared, and its default anonymous-link and file-safety settings.',
        sections: {
            'why-it-matters': 'why-it-matters',
            'how-microsoft-evaluates-it': 'how-microsoft-evaluates-it',
            'what-end-users-experience': 'what-end-users-experience',
        },
    },
    'baselines.sharing.org-anonymous-links-sharing-policy': {
        id: 'baselines.sharing.org-anonymous-links-sharing-policy',
        url: '/baselines/sharing/org-anonymous-links-sharing-policy/',
        title: 'Global Default Sharing Policy',
        description: 'Controls the organisation-wide sharing level for SharePoint and OneDrive.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.sharing.org-external-resharing': {
        id: 'baselines.sharing.org-external-resharing',
        url: '/baselines/sharing/org-external-resharing/',
        title: 'External (Guest) Users Resharing',
        description: 'This setting prevents external (guest) users from resharing content they have access to, ensuring that only authorized users can extend access to shared items.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.sharing.org-links-expiry': {
        id: 'baselines.sharing.org-links-expiry',
        url: '/baselines/sharing/org-links-expiry/',
        title: 'Anonymous Links Expiry',
        description: 'This policy sets an expiration date for anonymous sharing links, limiting how long external users can access shared content.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.sharing.sharepoint-infected-files-download': {
        id: 'baselines.sharing.sharepoint-infected-files-download',
        url: '/baselines/sharing/sharepoint-infected-files-download/',
        title: 'SharePoint Block Infected Files Download',
        description: 'This policy blocks users from downloading files in SharePoint and OneDrive that have been identified as infected with malware.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'cis': 'cis',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'baselines.sharing.sharepoint-storage-warning': {
        id: 'baselines.sharing.sharepoint-storage-warning',
        url: '/baselines/sharing/sharepoint-storage-warning/',
        title: 'SharePoint Storage Warning',
        description: 'Use this baseline to monitor the storage usage of selected SharePoint sites.',
        sections: {
            'settings-this-baseline-controls': 'settings-this-baseline-controls',
            'configure-it': 'configure-it',
            'check-it-worked': 'check-it-worked',
            'standards-this-addresses': 'standards-this-addresses',
            'nist': 'nist',
            'iso-27001': 'iso-27001',
            'gdpr': 'gdpr',
        },
    },
    'home': {
        id: 'home',
        url: '/',
        title: 'Octiga Docs',
        description: 'Learn how to secure and manage every client\'s Microsoft 365 tenant from one place with Octiga.',
        sections: {
            'recently-changed': 'recently-changed',
        },
    },
    'monitoring.account-risk': {
        id: 'monitoring.account-risk',
        url: '/monitoring/account-risk/',
        title: 'Account risks',
        description: 'Work through a tenant\'s per-user identity findings, such as dormant accounts, missing MFA and anonymous admins, and fix, dismiss or recheck them.',
        sections: {
            'the-risks': 'the-risks',
            'the-screen': 'the-screen',
            'search-and-filter': 'search-and-filter',
            'recheck-and-export': 'recheck-and-export',
            'the-account-risk-sheet': 'the-account-risk-sheet',
            'the-account-tab': 'the-account-tab',
            'the-history-tab': 'the-history-tab',
            'dismiss-and-un-dismiss': 'dismiss-and-un-dismiss',
            'several-findings-at-once': 'several-findings-at-once',
            'actions': 'actions',
        },
    },
    'monitoring.alerts': {
        id: 'monitoring.alerts',
        url: '/monitoring/alerts/',
        title: 'Alerts',
        description: 'Review, filter and dismiss every alert Octiga has raised across your tenants in one list, and see where alerts are sent.',
        sections: {
            'where-an-alert-comes-from': 'where-an-alert-comes-from',
            'the-alerts-screen': 'the-alerts-screen',
            'the-alert-side-sheet': 'the-alert-side-sheet',
            'where-alerts-go': 'where-alerts-go',
            'creating-an-event-rule-from-an-alert': 'creating-an-event-rule-from-an-alert',
            'actions': 'actions',
        },
    },
    'monitoring.event-rules': {
        id: 'monitoring.event-rules',
        url: '/monitoring/event-rules/',
        title: 'Event rules',
        description: 'Allow future Microsoft 365 events from countries, regions, network operators or IP addresses you trust, for whole tenants or chosen users.',
        sections: {
            'what-a-rule-does': 'what-a-rule-does',
            'check-what-your-rules-are-doing': 'check-what-your-rules-are-doing',
            'the-rules-list': 'the-rules-list',
            'the-rule-dialog': 'the-rule-dialog',
            'draw-a-region': 'draw-a-region',
            'delete-a-region': 'delete-a-region',
            'create-a-rule-from-settings': 'create-a-rule-from-settings',
            'create-a-rule-from-an-event-or-alert': 'create-a-rule-from-an-event-or-alert',
            'quieten-a-known-safe-network-operator': 'quieten-a-known-safe-network-operator',
            'edit-or-delete-a-rule': 'edit-or-delete-a-rule',
            'actions': 'actions',
        },
    },
    'monitoring.events': {
        id: 'monitoring.events',
        url: '/monitoring/events/',
        title: 'Events',
        description: 'Browse, filter and act on the Microsoft 365 audit events Octiga collects for one tenant, and check whether monitoring itself is healthy.',
        sections: {
            'what-is-monitored': 'what-is-monitored',
            'monitoring-health': 'monitoring-health',
            'the-monitoring-screen': 'the-monitoring-screen',
            'triggered-rules': 'triggered-rules',
            'the-filter-drawer': 'the-filter-drawer',
            'event-detail': 'event-detail',
            'actions': 'actions',
        },
    },
    'monitoring.respond-to-a-compromised-account': {
        id: 'monitoring.respond-to-a-compromised-account',
        url: '/monitoring/respond-to-a-compromised-account/',
        title: 'Respond to a compromised account',
        description: 'Spot a compromised Microsoft 365 account from Octiga\'s graded events and alerts, contain it, close the doors an attacker opened, and put the baselines in place that stop the next one.',
        sections: {
            'how-octiga-spots-it': 'how-octiga-spots-it',
            'contain-it': 'contain-it',
            'close-the-doors': 'close-the-doors',
            'clean-the-mailbox': 'clean-the-mailbox',
            'cut-off-any-app-the-attacker-added': 'cut-off-any-app-the-attacker-added',
            'prevent-the-next-one': 'prevent-the-next-one',
            'after-the-incident': 'after-the-incident',
        },
    },
    'not-found': {
        id: 'not-found',
        url: '/404/',
        title: 'Page not found',
        description: 'The page you\'re looking for doesn\'t exist or has moved.',
        sections: {},
    },
    'reference.glossary': {
        id: 'reference.glossary',
        url: '/reference/glossary/',
        title: 'Glossary',
        description: 'Short definitions of Octiga terms such as scheme, deviation, resolution and effective value.',
        sections: {
            'a': 'a',
            'b': 'b',
            'd': 'd',
            'e': 'e',
            'g': 'g',
            'm': 'm',
            'n': 'n',
            'o': 'o',
            'p': 'p',
            'r': 'r',
            's': 's',
            't': 't',
            'u': 'u',
            'v': 'v',
        },
    },
    'reference.licence-requirements': {
        id: 'reference.licence-requirements',
        url: '/reference/licence-requirements/',
        title: 'Licence requirements',
        description: 'See which Microsoft licence each baseline needs, and what happens when a tenant or user doesn\'t hold it.',
        sections: {
            'licence-groups': 'licence-groups',
            'entra-id-p1-or-p2': 'entra-id-p1-or-p2',
            'intune': 'intune',
            'sharepoint-online': 'sharepoint-online',
            'defender-for-office-365': 'defender-for-office-365',
            'customer-lockbox': 'customer-lockbox',
            'how-to-see-what-a-baseline-needs': 'how-to-see-what-a-baseline-needs',
            'when-a-licence-is-missing': 'when-a-licence-is-missing',
        },
    },
    'reference.security-and-data-handling': {
        id: 'reference.security-and-data-handling',
        url: '/reference/security-and-data-handling/',
        title: 'Security and data handling',
        description: 'Where Octiga runs, how it reaches a client tenant, who on your team can see what, what it keeps and for how long, and what happens when you remove a tenant.',
        sections: {
            'where-octiga-runs': 'where-octiga-runs',
            'how-octiga-reaches-a-client-tenant': 'how-octiga-reaches-a-client-tenant',
            'who-on-your-team-can-see-what': 'who-on-your-team-can-see-what',
            'what-octiga-changes-and-when': 'what-octiga-changes-and-when',
            'what-octiga-records': 'what-octiga-records',
            'removing-a-tenant': 'removing-a-tenant',
            'agreements': 'agreements',
        },
    },
    'reference.troubleshooting': {
        id: 'reference.troubleshooting',
        url: '/reference/troubleshooting/',
        title: 'Troubleshooting',
        description: 'Find the likely cause and the fix for common symptoms in Octiga, grouped by area.',
        sections: {
            'connection': 'connection',
            'sync': 'sync',
            'monitoring-health': 'monitoring-health',
            'baselines-and-deviations': 'baselines-and-deviations',
            'deploying': 'deploying',
            'signing-in': 'signing-in',
            'alerts-and-psa': 'alerts-and-psa',
            'reports': 'reports',
        },
    },
    'reference.what-octiga-needs-from-your-tenant': {
        id: 'reference.what-octiga-needs-from-your-tenant',
        url: '/reference/what-octiga-needs-from-your-tenant/',
        title: 'What Octiga needs from your tenant',
        description: 'What a client\'s Global Administrator consents to when connecting a tenant, and what Octiga uses each permission and directory role for.',
        sections: {
            'the-consent-in-plain-terms': 'the-consent-in-plain-terms',
            'two-applications': 'two-applications',
            'permissions-requested': 'permissions-requested',
            'directory-roles-octiga-assigns-to-itself': 'directory-roles-octiga-assigns-to-itself',
            'limits-on-this-access': 'limits-on-this-access',
        },
    },
    'start-here.connect-a-tenant': {
        id: 'start-here.connect-a-tenant',
        url: '/start-here/connect-a-tenant/',
        title: 'Connect a tenant',
        description: 'Connect a client\'s Microsoft 365 tenant to Octiga with a single-use consent link that the client\'s Global Administrator approves, and see what happens once the tenant is connected.',
        sections: {
            'start-the-connection': 'start-the-connection',
            'what-happens-next': 'what-happens-next',
            'if-the-link-expires-or-consent-fails': 'if-the-link-expires-or-consent-fails',
            'check-it-worked': 'check-it-worked',
        },
    },
    'start-here.how-octiga-works': {
        id: 'start-here.how-octiga-works',
        url: '/start-here/how-octiga-works/',
        title: 'How Octiga works',
        description: 'Learn how Octiga keeps each tenant\'s configuration in line with its baselines, grades its activity into alerts, and finds the accounts, mailboxes and applications at risk.',
        sections: {
            'sync': 'sync',
            'compare': 'compare',
            'act': 'act',
            'monitoring-activity': 'monitoring-activity',
            'findings-about-accounts-mailboxes-and-applications': 'findings-about-accounts-mailboxes-and-applications',
            'evidence-retention': 'evidence-retention',
            'vocabulary': 'vocabulary',
        },
    },
    'start-here.overview': {
        id: 'start-here.overview',
        url: '/start-here/overview/',
        title: 'Overview',
        description: 'See what Octiga does for your MSP, from keeping every client tenant on your security standard to watching what happens in them and fixing the accounts, mailboxes and apps at risk.',
        sections: {
            'what-octiga-does': 'what-octiga-does',
            'keep-every-tenant-on-your-standard': 'keep-every-tenant-on-your-standard',
            'see-whats-happening-in-every-tenant': 'see-whats-happening-in-every-tenant',
            'find-and-fix-the-accounts-mailboxes-and-apps-at-risk': 'find-and-fix-the-accounts-mailboxes-and-apps-at-risk',
            'fit-it-to-your-msp': 'fit-it-to-your-msp',
            'two-levels-msp-and-tenant': 'two-levels-msp-and-tenant',
            'where-to-go-next': 'where-to-go-next',
            'setting-up-octiga': 'setting-up-octiga',
            'working-in-octiga-day-to-day': 'working-in-octiga-day-to-day',
            'evaluating-octiga': 'evaluating-octiga',
        },
    },
    'start-here.questions': {
        id: 'start-here.questions',
        url: '/start-here/questions/',
        title: 'Questions about Octiga',
        description: 'Straight answers to the questions MSPs ask when evaluating Octiga, from what it needs in a client tenant to where it runs and how to get pricing.',
        sections: {
            'what-is-octiga-and-who-is-it-for': 'what-is-octiga-and-who-is-it-for',
            'can-our-clients-sign-in-and-what-do-they-see': 'can-our-clients-sign-in-and-what-do-they-see',
            'does-octiga-need-global-administrator-in-a-client-tenant': 'does-octiga-need-global-administrator-in-a-client-tenant',
            'what-does-a-client-approve-when-a-tenant-is-connected': 'what-does-a-client-approve-when-a-tenant-is-connected',
            'how-do-i-connect-a-client-tenant': 'how-do-i-connect-a-client-tenant',
            'does-octiga-read-email': 'does-octiga-read-email',
            'will-octiga-change-client-settings-without-asking': 'will-octiga-change-client-settings-without-asking',
            'does-octiga-block-an-account-automatically': 'does-octiga-block-an-account-automatically',
            'how-quickly-does-octiga-see-a-change-made-in-microsoft-365': 'how-quickly-does-octiga-see-a-change-made-in-microsoft-365',
            'which-psa-tools-does-it-create-tickets-in': 'which-psa-tools-does-it-create-tickets-in',
            'can-junior-technicians-see-every-client': 'can-junior-technicians-see-every-client',
            'which-microsoft-licences-are-needed-and-will-a-missing-licence-cause-false-alerts': 'which-microsoft-licences-are-needed-and-will-a-missing-licence-cause-false-alerts',
            'how-long-is-evidence-kept': 'how-long-is-evidence-kept',
            'where-is-octiga-hosted': 'where-is-octiga-hosted',
            'how-much-does-octiga-cost-and-how-do-i-start': 'how-much-does-octiga-cost-and-how-do-i-start',
        },
    },
    'start-here.roles-and-permissions': {
        id: 'start-here.roles-and-permissions',
        url: '/start-here/roles-and-permissions/',
        title: 'Roles and permissions',
        description: 'The four roles in Octiga, what each one can do, and how staff get access.',
        sections: {
            'the-four-roles': 'the-four-roles',
            'capability-matrix': 'capability-matrix',
            'tenant-reach': 'tenant-reach',
            'how-access-is-granted': 'how-access-is-granted',
            'hidden-or-disabled': 'hidden-or-disabled',
            'vocabulary': 'vocabulary',
        },
    },
    'tenants.applications': {
        id: 'tenants.applications',
        url: '/tenants/applications/',
        title: 'Applications',
        description: 'See which apps hold permissions in a tenant and how risky each one is, then disable an app, remove a permission or revoke a grant.',
        sections: {
            'whats-listed': 'whats-listed',
            'the-applications-screen': 'the-applications-screen',
            'turning-an-app-off-and-on': 'turning-an-app-off-and-on',
            'the-application-side-sheet': 'the-application-side-sheet',
            'octigas-own-app': 'octigas-own-app',
            'actions': 'actions',
            'disable-an-app': 'disable-an-app',
            'remove-an-application-permission': 'remove-an-application-permission',
            'revoke-a-delegated-grant': 'revoke-a-delegated-grant',
        },
    },
    'tenants.mail-flow': {
        id: 'tenants.mail-flow',
        url: '/tenants/mail-flow/',
        title: 'Mail flow',
        description: 'Review inbox rules, mailbox forwarding and remote-access risk for a tenant\'s mailboxes, and manage its transport rules.',
        sections: {
            'what-this-screen-governs': 'what-this-screen-governs',
            'mailboxes-tab': 'mailboxes-tab',
            'the-mailbox-side-sheet': 'the-mailbox-side-sheet',
            'transport-rules-tab': 'transport-rules-tab',
            'actions': 'actions',
            'flag-or-unflag-a-mailbox-finding': 'flag-or-unflag-a-mailbox-finding',
            'remove-a-suspicious-forwarding-rule': 'remove-a-suspicious-forwarding-rule',
            'disable-an-inbox-rule': 'disable-an-inbox-rule',
            'reorder-a-transport-rule': 'reorder-a-transport-rule',
            'delete-a-transport-rule': 'delete-a-transport-rule',
            'disable-a-legacy-protocol-on-a-mailbox': 'disable-a-legacy-protocol-on-a-mailbox',
        },
    },
    'tenants.offboard-a-user': {
        id: 'tenants.offboard-a-user',
        url: '/tenants/offboard-a-user/',
        title: 'Offboard a user',
        description: 'Close down a departing user\'s Microsoft 365 account, hand their mailbox on and return their licences in one run.',
        sections: {
            'offboard-a-user': 'offboard-a-user',
            'secure-the-account': 'secure-the-account',
            'hand-off-the-mailbox': 'hand-off-the-mailbox',
            'watch-the-run': 'watch-the-run',
            'retry-a-failed-step': 'retry-a-failed-step',
            'leave-a-run-and-come-back-to-it': 'leave-a-run-and-come-back-to-it',
            'the-history-tab': 'the-history-tab',
            'check-it-worked': 'check-it-worked',
            'what-the-wizard-leaves-alone': 'what-the-wizard-leaves-alone',
            'what-you-can-undo': 'what-you-can-undo',
            'if-it-didnt-work': 'if-it-didnt-work',
        },
    },
    'tenants.onboard-a-user': {
        id: 'tenants.onboard-a-user',
        url: '/tenants/onboard-a-user/',
        title: 'Onboard a user',
        description: 'Create a Microsoft 365 user from Octiga, with their sign-in, password, licences and group memberships, in one five-step wizard.',
        sections: {
            'create-the-user': 'create-the-user',
            'hand-over-the-password': 'hand-over-the-password',
            'check-it-worked': 'check-it-worked',
            'what-happens-next': 'what-happens-next',
            'if-it-didnt': 'if-it-didnt',
        },
    },
    'tenants.reports': {
        id: 'tenants.reports',
        url: '/tenants/reports/',
        title: 'Security reports',
        description: 'Run a security report for one tenant, read it in Octiga, download the PDF and follow every scheduled send.',
        sections: {
            'the-reporting-page': 'the-reporting-page',
            'actions': 'actions',
            'run-a-report': 'run-a-report',
            'while-it-generates': 'while-it-generates',
            'reading-a-report': 'reading-a-report',
            'pdf-file-names': 'pdf-file-names',
            'emailed-reports': 'emailed-reports',
            'how-long-reports-are-kept': 'how-long-reports-are-kept',
        },
    },
    'tenants.tenant-settings': {
        id: 'tenants.tenant-settings',
        url: '/tenants/tenant-settings/',
        title: 'Tenant settings',
        description: 'Check a tenant\'s details, choose whether Octiga can remediate it automatically, turn on auto-block for every user, or remove the tenant from Octiga.',
        sections: {
            'opening-tenant-settings': 'opening-tenant-settings',
            'the-tenant-settings-sheet': 'the-tenant-settings-sheet',
            'allow-auto-remediation': 'allow-auto-remediation',
            'auto-block': 'auto-block',
            'remove-tenant': 'remove-tenant',
            'actions': 'actions',
        },
    },
    'tenants.tenants-and-dashboard': {
        id: 'tenants.tenants-and-dashboard',
        url: '/tenants/tenants-and-dashboard/',
        title: 'Tenants and dashboard',
        description: 'Find a client tenant, read its dashboard, and move around Octiga quickly from anywhere.',
        sections: {
            'the-tenants-list': 'the-tenants-list',
            'actions': 'actions',
            'the-tenant-dashboard': 'the-tenant-dashboard',
            'keeping-it-up-to-date': 'keeping-it-up-to-date',
            'widget-states': 'widget-states',
            'dashboard-actions': 'dashboard-actions',
            'more-tiles': 'more-tiles',
            'getting-around': 'getting-around',
            'search-k--ctrlk': 'search-k--ctrlk',
            'starring': 'starring',
            'switching-tenant-from-the-breadcrumb': 'switching-tenant-from-the-breadcrumb',
            'the-tenant-menu-right-click': 'the-tenant-menu-right-click',
            'quick-add': 'quick-add',
            'more-quick-add-shortcuts': 'more-quick-add-shortcuts',
        },
    },
    'tenants.user-management': {
        id: 'tenants.user-management',
        url: '/tenants/user-management/',
        title: 'User management',
        description: 'Find any user in a tenant, see whether they can sign in and what risks they carry, and block them or change their identity, roles, groups and licences.',
        sections: {
            'the-roster': 'the-roster',
            'lenses-search-and-filters': 'lenses-search-and-filters',
            'the-table-view': 'the-table-view',
            'acting-on-users': 'acting-on-users',
            'the-user-menu': 'the-user-menu',
            'working-with-several-users': 'working-with-several-users',
            'actions': 'actions',
            'the-user-sheet': 'the-user-sheet',
            'the-account-tab': 'the-account-tab',
            'editing-identity-roles-groups-and-licences': 'editing-identity-roles-groups-and-licences',
            'the-history-tab': 'the-history-tab',
        },
    },
    'tenants.user-remedies': {
        id: 'tenants.user-remedies',
        url: '/tenants/user-remedies/',
        title: 'User remedies',
        description: 'Block or unblock a user\'s sign-in, end their sessions, reset their password, or let Octiga block an account automatically after a serious risk event.',
        sections: {
            'block-sign-in': 'block-sign-in',
            'unblock-sign-in': 'unblock-sign-in',
            'revoke-sessions': 'revoke-sessions',
            'reset-password': 'reset-password',
            'auto-block': 'auto-block',
            'turn-auto-block-on-or-off-for-a-user': 'turn-auto-block-on-or-off-for-a-user',
            'turn-auto-block-on-or-off-for-every-user': 'turn-auto-block-on-or-off-for-every-user',
            'run-a-remedy-on-several-users': 'run-a-remedy-on-several-users',
            'what-each-remedy-changes-and-how-to-reverse-it': 'what-each-remedy-changes-and-how-to-reverse-it',
        },
    },
} as const;

/** Union of all known doc IDs — referencing a removed page is a compile error. */
export type DocId = keyof typeof kosRegistry;
